export default __webpack_public_path__ + "static/media/Corporate.c060adcc.png";